// The scorecard's arithmetic (80.8), shared by the box and its tests: the
// band a rate falls in, and the figures in words.
import type { BandName } from "@/lib/api";

/** The band of a rate, rounded half up to a whole percent: red 0–49, pink
 *  50–60, yellow 61–70, amber 71–80, pale green 81–90, green 91–100. */
export function bandOf(rate: number): BandName {
  const percent = Math.min(100, Math.max(0, Math.floor(rate * 100 + 0.5)));
  if (percent <= 49) return "red";
  if (percent <= 60) return "pink";
  if (percent <= 70) return "yellow";
  if (percent <= 80) return "amber";
  if (percent <= 90) return "pale-green";
  return "green";
}

export function percent(rate: number | null): string {
  if (rate === null) return "—";
  return `${Math.floor(rate * 100 + 0.5)}%`;
}

/** The change since the last run in words. With no change to read, a set
 *  that has an earlier run says there is nothing to compare (one of the two
 *  runs has no keyed answers); only a set with no earlier run says first run. */
export function deltaWords(delta: number | null, hasPrior = false): string {
  if (delta === null) return hasPrior ? "nothing to compare" : "first run";
  const points = Math.floor(Math.abs(delta) * 100 + 0.5);
  if (points === 0) return "no change";
  return `${delta > 0 ? "up" : "down"} ${points} ${points === 1 ? "point" : "points"}`;
}
